<!--
 * @Author: cong
 * @Date: 2021-11-08 15:27:09
 * @LastEditTime: 2021-11-08 17:46:33
 * @LastEditors: cong
 * @Description: 
 * @FilePath: \qlh-vue-web\src\views\accounting\cwacount\list.vue
-->
<template>
  <div class="tab-body">
    <div class="operator">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="toSave()"
        v-has-permission-code-and="'003500250000'"
        >添加</el-button
      >
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <qlh-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        v-loading="listLoading"
      >
         <qlh-table-column width="210px" prop="crtm" label="创建时间"></qlh-table-column>
        <qlh-table-column width="120px" prop="begin" label="开始时间"></qlh-table-column>
        <qlh-table-column width="120px" prop="end" label="结束时间"></qlh-table-column>
        <qlh-table-column width="90px"  prop="person" label="个人部分"></qlh-table-column>
        <qlh-table-column width="90px" prop="cmpy" label="公司部分"></qlh-table-column>
        <qlh-table-column   prop="cmpy" label="合计">
          <template slot-scope="scope" v-if="scope.row">
            {{ (scope.row.cmpy -scope.row.person ).toFixed(2) }} 
          </template>
        </qlh-table-column>
        <qlh-table-column width="90px"  prop="state" label="状态" ></qlh-table-column>
        <qlh-table-column label="操作" fixed="right" width="200px" ignored>
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button v-if="scope.row.state=='启用'"
                v-has-permission-code-and="'003500250000'"
                size="mini"
                type="danger"
                @click="toDeactivate(scope.$index, scope.row)"
                >停用</el-button>
             <el-button v-if="scope.row.state=='停用'"
                v-has-permission-code-and="'003500250000'"
                size="mini"
                type="success"
                @click="toDeactivate(scope.$index, scope.row)"
                >启用</el-button>
            </div>
          </template>
        </qlh-table-column>
      </qlh-table>
    </div>
      <edit ref="edit"></edit>
  </div>
</template>
<script>
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import api from "@/api/cw/sebao.js";
import edit from "./edit.vue";

export default {
  name: "cwacount",
  components: {
    qlhTable,
    qlhTableColumn,
    edit
  },
  data() {
    return {
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;
      api.list(null, (response) => {
        console.log(response)
        this.listData = response.data;
        this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      this.$refs.edit.open({}, "添加");
    },
    toDeactivate(index, row) {
		let updateState
		if (row.state == '启用') {
			updateState = '停用' 
		}else{
			updateState = '启用'
		}
      let parameter = {
        id: row.id,
        state: updateState,
      };
      this.$utils.confirm.warning("提示", "确定修改吗？", () => {
        api.update(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
  },
  mounted() {
    this.list();
  }
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

</style>

